import type { KudoContentObjectDetail, KudoContentObjectList } from 'models';
import { useCallback, useMemo } from 'react';
import { useConfirmDelete } from '../../../hooks';
import { useDeleteKudoContentObjectMutation } from '../../../queries';

export const useDeleteKudoConfirmModal = () => {
  const { mutateAsync: deleteKudo } = useDeleteKudoContentObjectMutation();
  const { confirm, contextHolder } = useConfirmDelete();

  const confirmDelete = useCallback(
    ({
      item,
      onSuccess,
      title,
    }: {
      item: KudoContentObjectDetail | KudoContentObjectList;
      onSuccess: () => void;
      title: string;
    }) => {
      confirm({
        async onOk() {
          await deleteKudo(
            { contentObject: item },
            {
              onSuccess,
            },
          );
        },
        title,
      });
    },
    [confirm, deleteKudo],
  );

  return useMemo(
    () => ({
      confirm: confirmDelete,
      contextHolder,
    }),
    [confirmDelete, contextHolder],
  );
};
